// DS: MO3.9
import React from 'react';
import cn from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { useTranslation } from 'react-i18next';
import { getDeviationDiscount } from '../../../../utils/deviations';
import s from './DeviationThumbDiscountLabel.scss';

interface Props {
  className?: string;
  deviation: PapiDeviation;
  textVariant?: 'up-to-x-off' | 'sale-x-off' | 'you-save-x';
}

const DeviationThumbDiscountLabel: React.FC<Props> = ({
  className,
  deviation,
  textVariant = 'up-to-x-off',
}) => {
  const { t } = useTranslation();
  const { discount, formattedDiscountDollarAmount } =
    getDeviationDiscount(deviation);

  if (!discount) {
    return null;
  }

  let label;
  if (textVariant === 'up-to-x-off') {
    if (discount?.amount?.percent) {
      label = t('deviationview.thumb.discountLabel.upToPercentOff', {
        percentage: discount.amount.percent.toFixed(0),
      });
    }
  } else if (textVariant === 'sale-x-off') {
    if (discount?.amount?.percent) {
      label = t('deviationview.thumb.discountLabel.salePercentOff', {
        percentage: discount.amount.percent.toFixed(0),
      });
    }
  } else if (textVariant === 'you-save-x') {
    if (discount?.amount?.usd) {
      label = t('deviationview.thumb.discountLabel.youSave', {
        dollarAmount: formattedDiscountDollarAmount,
      });
    }
  }
  if (!label) {
    return null;
  }
  return (
    <div className={cn(s['root'], className)}>
      <abbr title={label}>{label}</abbr>
    </div>
  );
};
DeviationThumbDiscountLabel.displayName = 'DeviationThumbDiscountLabel';

export default DeviationThumbDiscountLabel;
